module.exports = __webpack_public_path__ + "img/whatsapp.802550a4.png";